import { dataAnalyticsTitlesAndPath } from '../utils/routeTitleConnection';

export const dataAnalyticsTableHeader = {
  [`/${dataAnalyticsTitlesAndPath.ACTIVE_TUTORS}`]: [
    { field: 'sl_no', headerName: 'SlNo', width: 140 },
    { field: 'trainer_id', headerName: 'Trainer ID', width: 140 },
    { field: 'full_name', headerName: 'Trainer Name', width: 250, toolTipGetter: true },
    { field: 'project_names', headerName: 'Project', width: 200 },
    { field: 'total_session', headerName: 'Total Sessions', width: 160 },
    { field: 'total_sessions_this_period', headerName: 'Sessions (Month)', width: 180 },
    { field: 'mobile_number', headerName: 'Contact Details', width: 200 },
  ],

  [`/${dataAnalyticsTitlesAndPath.TRAINER_UNMAPPED}`]: [
    { field: 'sl_no', headerName: 'SlNo', width: 140 },
    { field: 'trainer_id', headerName: 'Trainer ID', width: 140 },
    { field: 'trainer_name', headerName: 'Trainer Name', width: 250, toolTipGetter: true },
    { field: 'trainer_unmap_reason', headerName: 'Unmap Reason', width: 220, toolTipGetter: true },
    { field: 'student_name', headerName: 'Student Name', width: 200, toolTipGetter: true },
    { field: 'admn_no', headerName: 'Admission No', width: 180 },
    { field: 'cro_name', headerName: 'CRO Name', width: 180 },
    { field: 'trainer_unmap_timestamp', headerName: 'Unmap Timestamp', width: 200 },
  ],

  [`/${dataAnalyticsTitlesAndPath.NEWLY_ASSIGNED_TUTORS}`]: [
    { field: 'trainer_id', headerName: 'Trainer ID', width: 140 },
    { field: 'trainer_name', headerName: 'Trainer Name', width: 250, toolTipGetter: true },
    { field: 'mobile_number', headerName: 'Contact Details', width: 200 },
    { field: 'assignedAt', headerName: 'Assignment Timestamp', width: 220 },
    { field: 'subject_name', headerName: 'Assigned Subject', width: 180 },
    { field: 'croName', headerName: 'CRO Name', width: 180 },
  ],

  [`/${dataAnalyticsTitlesAndPath.ACTIVE_TUTORS_SUBJECT}`]: [
    { field: 'trainer_id', headerName: 'Trainer ID', width: 140 },
    { field: 'trainer_name', headerName: 'Trainer Name', width: 250, toolTipGetter: true },
    { field: 'mobile_number', headerName: 'Contact Details', width: 200 },
    { field: 'last_attendance_timestamp', headerName: 'Last Attendance', width: 200 },
    { field: 'subject_name', headerName: 'Subject Name', width: 180 },
    { field: 'trainer_total_sessions', headerName: 'Total Sessions', width: 160 },
    { field: 'trainer_sessions_for_this_subject', headerName: 'Subject Sessions', width: 180 },
  ],

  [`/${dataAnalyticsTitlesAndPath.STUDENT_TUTOR_RATIO}`]: [
    { field: 'trainer_id', headerName: 'Trainer ID', width: 140 },
    { field: 'trainer_name', headerName: 'Trainer Name', width: 250, toolTipGetter: true },
    { field: 'studentName', headerName: 'Student Name', width: 200 },
    { field: 'croName', headerName: 'CRO Name', width: 180 },
    { field: 'activeStudents', headerName: 'Active Students', width: 180 },
  ],

  [`/${dataAnalyticsTitlesAndPath.TUTOR_CHANGE_DATA}`]: [
    { field: 'trainer_id', headerName: 'Trainer ID', width: 140 },
    { field: 'trainer_name', headerName: 'Trainer Name', width: 250, toolTipGetter: true },
    { field: 'changeCount', headerName: 'Tutor Change Count', width: 200 },
  ],

  [`/${dataAnalyticsTitlesAndPath.INACTIVE_TUTORS}`]: [
    { field: 'trainer_id', headerName: 'Trainer ID', width: 140 },
    { field: 'trainer_name', headerName: 'Trainer Name', width: 250, toolTipGetter: true },
    { field: 'changeCount', headerName: 'Tutor Change Count', width: 200 },
  ],
};
